export default __webpack_public_path__ + "static/media/unreadIcon.9a59bbee.svg";